import { render, staticRenderFns } from "./modal-social-add-members.vue?vue&type=template&id=2566b789&scoped=true&lang=pug"
import script from "./modal-social-add-members.js?vue&type=script&lang=js&external"
export * from "./modal-social-add-members.js?vue&type=script&lang=js&external"
import style0 from "./modal-social-add-members.vue?vue&type=style&index=0&id=2566b789&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2566b789",
  null
  
)

export default component.exports